import { render, staticRenderFns } from "./ParamsAgencyCatalogServices.vue?vue&type=template&id=68a3bb5e&"
import script from "./ParamsAgencyCatalogServices.vue?vue&type=script&lang=js&"
export * from "./ParamsAgencyCatalogServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QForm,QItemSection,QBtn});
